/* eslint-disable react/no-array-index-key */
import React, { useState, useContext } from 'react';
import intl from 'react-intl-universal';
import { InputNumber, Popconfirm, Button, Divider, message, Tooltip } from 'antd';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { parseFen2Currency, parseYuan2Fen } from '@/utils/number';
import IntlContext from '@/components/Intl/IntlContext';

import styles from './index.module.scss';

// 列表
function Index($$: any) {
  const { orderNo, goodTotalInfo, orderChangePrice, getOrderInfos } = $$;

  // 改价弹框是否显示
  const [pop, setPop] = useState(false);
  // save loading
  const [saveLoading, setSaveLoading] = useState(false);

  // 改后的价格
  const [discountPrice, setDiscountPrice] = useState<any>('');

  const intlCtx = useContext(IntlContext);

  const limitDecimals = (value) => {
    return Number(value)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  };

  // 确认改价
  const editPrice = async () => {
    if (discountPrice === '') {
      message.warning(intl.get('goods_enter_discounted_price'));
      return;
    }

    // 需要将discountPrice转成分
    const price = Number(parseYuan2Fen(discountPrice));

    if (price > goodTotalInfo.settleTotalActualPrice) {
      message.warning(intl.get('goods_discounted_price_cannot_than_original_price'));
      return;
    }

    if (price < 0) {
      message.warning(intl.get('goods_discounted_price_cannot_less_than_zero'));
      return;
    }

    try {
      setSaveLoading(true);
      const { code } = await orderChangePrice({
        orderNo,
        totalActualPrice: price,
      });

      if (code === 0) {
        setPop(false);
        getOrderInfos(orderNo);
      }
      setSaveLoading(false);
    } catch (error) {
      setSaveLoading(false);
      message.error(JSON.stringify(error));
    }
  };

  // 改价 input check
  const amountCheck = (e: any) => {
    const val = Number(e.target.value);
    setDiscountPrice(val);
  };

  return (
    <div className={styles.totalInfo}>
      <div className={styles.leftTotal}>
        <span className={styles.totalNumber}>共 {goodTotalInfo.settleTotalCount} 件外设</span>
        <div className={styles.totalTimesAndPrice}>
          <span className={styles.totalTimes}>
            共 {goodTotalInfo.settleTotalTimeCount || 0} 次租借{' '}
            <Tooltip title="总租借次数指 每个外设的数量乘以每个外设的租借次数并相加">
              <InfoCircleOutlined style={{ color: '#969799' }} />
            </Tooltip>
          </span>
          <span>
            {intl.get('goods_total_proce', {
              price: parseFen2Currency(goodTotalInfo.settleTotalActualPrice || 0),
            })}
          </span>
          {goodTotalInfo.settleTotalActualPrice !== goodTotalInfo.actualPay && (
            <>
              {intl.get('goods_discount_price')}
              <span>{parseFen2Currency(goodTotalInfo.actualPay || 0)}</span>
            </>
          )}
        </div>
      </div>
      <div className={styles.rightTotal}>
        <span>
          {intl.get('goods_final_payable')} <i>{parseFen2Currency(goodTotalInfo.actualPay || 0)}</i>
          <Popconfirm
            title={
              <div className={styles.popContent}>
                <InputNumber
                  controls={false}
                  prefix={intlCtx.TenantBaseConfig.CurrencySymbol}
                  value={discountPrice}
                  style={{ width: 250 }}
                  min={0}
                  precision={2}
                  formatter={limitDecimals}
                  parser={limitDecimals}
                  placeholder={intl.get('goods_enter_discounted_price')}
                  onBlur={amountCheck}
                  onPressEnter={amountCheck}
                />
                <Button
                  type="link"
                  loading={saveLoading}
                  onClick={editPrice}
                  style={{ marginLeft: 12 }}
                >
                  {intl.get('app_search_form_save_btn')}
                </Button>
                <Divider type="vertical" />
                <Button type="link" onClick={() => setPop(false)}>
                  {intl.get('app_confirm_cancel_btn')}
                </Button>
              </div>
            }
            disabled
            icon={null}
            placement="bottomRight"
            overlayClassName="editPopConfirm"
            visible={pop}
          >
            <Button
              style={{ backgroundColor: 'inherit', border: 'none' }}
              icon={<EditOutlined />}
              onClick={(e) => {
                e.preventDefault();
                setPop(!pop);
              }}
            />
          </Popconfirm>
        </span>
      </div>
    </div>
  );
}

export default Index;
